import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=519d164a&scoped=true&"
import script from "./InfoView.vue?vue&type=script&lang=ts&"
export * from "./InfoView.vue?vue&type=script&lang=ts&"
import style0 from "./InfoView.vue?vue&type=style&index=0&id=519d164a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d164a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
